import { KameleoonGoalData } from '../kameleoonGoals';
import { useTrackConversion } from '../useTrackConversion';

/**
 * Hook to track when a user clicks the Get App button in the mobile banner
 */
export const useTrackGetAppBannerClick = () => {
    const trackConversion = useTrackConversion({ goal: KameleoonGoalData.GetAppBannerClicked });

    return () => {
        trackConversion();
    };
};
